import React from 'react';
import { Icon } from './Icon.js';
export const IconConnections = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6.5 6.5L17.5 17.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17.5 6.5L6.5 17.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12.6067 2.00003L11.3866 2.00004L2 11.3866L2 12.6065L11.3935 22L12.5998 22L22 12.5998L22 11.3934L12.6067 2.00003Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconConnections.js.map